export const ModalBoxes = () => import(/* webpackChunkName: "views/more/ModalBoxes" */ './ModalBoxes.vue')
